export default __webpack_public_path__ + "static/media/transaction2.c97bd9e0.svg";